export default "__VITE_ASSET__BtzKW5S5__"